'use strict';

import reject from 'lodash/collection/reject';
import AppDispatcher from '../AppDispatcher';
import ActionTypes from '../constants/ActionTypes';
import ZineStore from './ZineStore';
import isBestOf2014Special from '../utils/isBestOf2014Special';
import { createIndexedListStore, createListActionHandler } from '../utils/PaginatedStoreUtils';

const ZineSectionStore = createIndexedListStore({
  getZines(sectionId) {
    const zines = this.getIds(sectionId).map(ZineStore.get);
    const specialZine = zines.filter(isBestOf2014Special)[0];

    if (!specialZine) {
      return zines;
    } else {
      return [specialZine].concat(reject(zines, isBestOf2014Special));
    }
  }
});

const handleListAction = createListActionHandler({
  request: ActionTypes.REQUEST_ZINES_IN_SECTION,
  error: ActionTypes.REQUEST_ZINES_IN_SECTION_ERROR,
  success: ActionTypes.REQUEST_ZINES_IN_SECTION_SUCCESS,
  preload: ActionTypes.PRELOAD_ZINES_IN_SECTION
});

AppDispatcher.register(function (payload) {
  AppDispatcher.waitFor([ZineStore.dispatchToken]);
  const sectionId = payload.action.sectionId;

  if (sectionId) {
    handleListAction(payload.action, ZineSectionStore.getList(sectionId), ZineSectionStore.emitChange);
  }
});

export default ZineSectionStore;


/** WEBPACK FOOTER **
 ** ./stores/ZineSectionStore.js
 **/